export const getPhoneNumberFormat = (format: string) =>
    format
        .replace(/^\+[.]+\s*/, '') //remove country prefix
        .replace(/[)(\-]/g, ' ') //change (, ), and - to whitespaces
        .replace(/\s\s+/g, ' ') //merge multiple whitespaces into one space
        .replace(/\./g, '9') //replace . with 9
        .trim();

export const formatWithMask = (value: string, mask: string) => {
    const parsedValue = value.replace(/\D/g, '');
    let formattedValue = '';
    let index = 0;

    for (const element of mask) {
        if (parsedValue[index] === undefined) break;

        if (!!element.trim()) formattedValue += parsedValue[index++];
        else formattedValue += ' ';
    }

    return formattedValue;
};
